"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetStartedCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      {}
      <div className={`absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475438/img/consultation_background_abstract.png)] transition-transform duration-[6000ms] ease-out ${isVisible ? "scale-[1.02]" : "scale-100"}`} aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-dark-background/70" aria-hidden="true" />

      {}
      <div className={`relative z-10 max-w-3xl mx-auto px-6 py-16 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="text-4xl md:text-5xl font-sans font-bold text-white mb-6">
          Ready to Build What's Next?
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
          Let's discuss your goals and how we can support your next stage of growth.
        </p>
        <Link to="/ContactPage">
          <Button size="lg" className="btn-primary relative overflow-hidden group px-8 py-4 text-base font-semibold">
            <span className="relative z-10">Schedule a Consultation</span>
            {}
            <span className="absolute inset-0 bg-white/20 scale-0 rounded-full group-hover:scale-100 group-active:scale-110 transition-transform duration-300 ease-out" />
          </Button>
        </Link>
      </div>
    </section>;
}